<template>
  <BreadCrumb class="hidden sm:block" />
  <ExpertOverviewPage :entry="entry" />
</template>

<script>
import gql from 'graphql-tag';
import { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import ExpertOverviewPage, { ExpertOverviewPageFragment } from '@/components/experts/ExpertOverviewPage';
import { stripLocale } from '@/utils/i18n';
import { normalizeTypeHandles } from '@/utils/common';
import { useEntryPage } from '@/composables/useEntryPage';
import BreadCrumb from '@/components/layout/BreadCrumb';

export const ExpertOverviewPageQuery = gql`
  query ExpertOverviewPageQuery($site: String!, $uri: String!) {
    entry(section: "experts", site: [$site], uri: [$uri]) {
      ...EntryPageFragment
      ...ExpertOverviewPageFragment
    }

    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }

  ${EntryPageFragment}
  ${ExpertOverviewPageFragment}
  ${SeomaticFragment}
`;

export default defineNuxtComponent({
  name: 'ExpertOverviewPageController',

  components: { ExpertOverviewPage, BreadCrumb },

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const { locale } = useNuxtApp().$i18n;
    const uri = stripLocale(route.path, locale.value);
    const variables = { site: locale.value, uri };

    const { entry, seomatic } = await $craftRequest(ExpertOverviewPageQuery, variables);

    entry.contentBlocks = normalizeTypeHandles(entry.contentBlocks);

    return { entry, seomatic };
  },

  created() {
    useEntryPage(this.entry, this.seomatic);
  },
});
</script>
